<template>
  <div v-loading="loading" class="page-content_wrapper bid-detail" :style="{ height: loading ? '150px' : 'auto' }">
    <template v-if="detail || true">
      <div class="bid-title">{{ detail.name }}</div>

      <!-- 流标 -->
      <img v-if="detail.status === 4" class="status-image" src="@/assets/images/icon-round-none.png">
      <!-- 供应商投标结果 -->
      <template v-if="(detail.status === 3 || detail.status === 5) && detail.bidStatus">
        <!-- 中标 -->
        <img v-if="detail.providerId === user.id" class="status-image" src="@/assets/images/icon-round-win.png">
        <!-- 未中标 -->
        <img v-else class="status-image" src="@/assets/images/icon-round-lose.png">
      </template>

      <div class="bid-info">
        <div class="bid-info-left">
          <div class="bid-info-item bid-release-time">发布时间：{{ detail.createTime }}</div>
          <!-- 公告 -->
          <template v-if="detail.status === 1">
            <div class="bid-info-item bid-time-deadline" :class="{ 'bid-time-end': false }">
              招标截止时间：
              <span>{{ false ? '已截止' : detail.registrationEndTime }}</span>
            </div>
          </template>

          <!-- 中标 -->
          <template v-if="detail.status === 3 || detail.status === 5">
            <div class="bid-info-item bid-win-company">中标公司：{{ (user ? detail.providerName : '') | asteriskFilter }}</div>
            <div class="bid-info-item bid-win-amount">
              中标金额：
              <!-- <span>{{ user ? (detail.price || 0) : '*****' }}</span> -->
              <span>*****</span>
            </div>
          </template>
        </div>
        <div class="bid-info-item bid-state">
          项目状态：
          <span v-if="detail.status === 1" class="state-tag state-invite">招标中</span>
          <span v-if="detail.status === 2" class="state-tag state-review">评审中</span>
          <span v-if="detail.status >= 3" class="state-tag state-win">已开标</span>
        </div>
      </div>

      <panel class="bid-wrapper" title="招标正文" icon="assets/images/icon-template-blue.png">
        <template slot="right">
          <div class="bid-detail-actions">
            <template v-if="detail.status === 1">
              <!-- 更新标书 -->
              <template v-if="detail.bidStatus && detail.userBidUrl">
                <span class="uploaded-bids">
                  <a target="_blank" :href="detail.userBidUrl">{{ detail.userBidUrl }}</a>
                </span>
                <el-button type="primary" @click="submitBids">更新标书</el-button>
              </template>

              <!-- 邀约 -->
              <template v-else-if="detail.invitationType && detail.inviteUserStatus !== 1">
                <template v-if="detail.inviteUserStatus === 0">
                  <el-button @click="refused">不接受</el-button>
                  <el-button type="primary" @click="submitBids">接受邀约</el-button>
                </template>
                <el-button v-if="detail.inviteUserStatus === 2" type="primary" @click="submitBids">上交标书</el-button>
              </template>

              <!-- 投标 -->
              <el-button v-else type="primary" @click="submitBids">我要投标</el-button>
            </template>

            <!-- 收藏相关 -->
            <el-button
              v-if="detail.collectionType"
              class="cancel-collect-button"
              @click="cancelCollect"
            >取消收藏</el-button>
            <el-button
              v-else
              class="collect-button"
              @click="collect"
            >收藏项目</el-button>
          </div>
        </template>
        <div class="bid-content">
          <cell-group title="项目基本信息">
            <cell label="招标内容">{{ detail.content }}</cell>
            <cell label="工期要求">{{ detail.timeRequire }}</cell>
            <cell label="资质要求">{{ detail.aptitudeRequire }}</cell>
            <cell label="项目金额">{{ detail.projectPrice > 0 ? detail.projectPrice : '' }}</cell>
            <cell label="投标保证金">{{ detail.marginMoney }}</cell>
            <cell v-if="detail.bidTemplate.length > 0" label="附件">
              <div v-for="(item, index) in detail.bidTemplate" :key="index" class="templete-item">
                {{ item.name }}
                <a :href="item.url" target="__blank" :download="item.name">
                  <el-button class="btn-preview" size="mini" type="primary">点击预览</el-button>
                </a>
              </div>
            </cell>
          </cell-group>
          <cell-group title="项目时间">
            <cell label="招标时间">{{ detail.registrationTime }} —— {{ detail.registrationEndTime }}</cell>
            <cell label="开标时间">{{ detail.openTime }} —— {{ detail.openEndTime }}</cell>
            <cell label="公示时间">{{ detail.reviewStartTime }} —— {{ detail.reviewEndTime }}</cell>
          </cell-group>
          <cell-group title="联系人信息">
            <cell label="联系人">{{ detail.linkman }}</cell>
            <cell label="联系电话">{{ detail.phone }}</cell>
            <cell label="传真">{{ detail.fax }}</cell>
            <cell label="E-mail">{{ detail.eMail }}</cell>
            <cell label="通讯地址">{{ detail.addr }}</cell>
          </cell-group>
        </div>
      </panel>

      <!-- 投标资料上传弹窗 -->
      <el-dialog title="报名投标" :visible.sync="showBidDiaolog" width="628px">
        <el-form label-position="left" label-width="105px" :model="form">
          <el-form-item label="请上传文件">
            <el-upload
              ref="upload"
              action=""
              accept=".pdf"
              :auto-upload="false"
              :http-request="uploadFile"
              :file-list="fileList"
              :on-change="uploadChange"
            >
              <div slot="tip" class="el-upload__tip">只能上传pdf文件</div>
              <el-button slot="trigger" class="upload-button" plain icon="el-icon-plus">选取文件</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="公司名称">{{ user.companyName }}</el-form-item>
          <el-form-item label="联系人姓名">{{ user.contact }}</el-form-item>
          <el-form-item label="联系人电话">{{ user.phone }}</el-form-item>
        </el-form>
        <template slot="footer">
          <el-button class="submit-button" :disabled="fileList.length <= 0" type="primary" @click="$refs.upload.submit()">确认标书文件无误，提交审核</el-button>
        </template>
      </el-dialog>
    </template>
  </div>
</template>

<script>
import Panel from '@/components/Panel'
import CellGroup from '@/components/CellGroup'
import Cell from '@/components/Cell'

import { mapState } from 'vuex'

import loginCheck from '@/mixins/loginCheck'

import {
  fetchBidDetail,
  collectBid,
  cancelCollectBid,
  acceptInvite,
  refusedInvite,
  uploadFile,
  uploadBidFile,
  updateBidFile
} from '@/api'

export default {

  components: {
    Panel,
    CellGroup,
    Cell
  },

  filters: {
    asteriskFilter(value = '') {
      if (!value) return '*****'

      const { length: len = 0 } = value
      const prefix = value.slice(0, Math.min(Math.floor(len / 2), 4))
      const suffix = value.slice(-Math.min(Math.floor(len / 2), 2))

      return `${prefix}*****${suffix}`
    }
  },
  mixins: [loginCheck],

  data() {
    return {
      detail: '',

      form: {},

      fileList: [],
      showBidDiaolog: false,
      loading: false
    }
  },

  computed: {
    ...mapState([
      'user'
    ])
  },

  watch: {
    showBidDiaolog: function(newVal) {
      if (!newVal) {
        this.$refs.upload.clearFiles()
      }
    }
  },

  mounted() {
    this.fetchDetail()
  },

  methods: {
    /*
     * 获取详情
     */
    async fetchDetail() {
      const { id, inviteId } = this.$route.query
      const params = {
        id: id
      }

      if (inviteId) {
        Object.assign(params, {
          inviteId
        })
      }

      this.loading = true

      try {
        const { data } = await fetchBidDetail(params)

        data.bidTemplate = data.bidTemplate ? JSON.parse(data.bidTemplate) : []

        this.detail = data
      } catch (error) {
        this.$message.error(error.message)
      }

      this.loading = false
    },

    /*
     * 收藏项目
     */
    async collect() {
      if (this.loginCheck()) {
        try {
          await collectBid({ id: this.$route.query.id })

          this.detail.collectionType = true

          this.$message.success('收藏成功！')
        } catch (error) {
          this.$message.error(error.message)
        }
      }
    },

    /*
     * 取消收藏
     */
    async cancelCollect() {
      if (this.loginCheck()) {
        try {
          await cancelCollectBid({ id: this.$route.query.id })

          this.detail.collectionType = false

          this.$message.success('取消收藏成功！')
        } catch (error) {
          this.$message.error(error.message)
        }
      }
    },

    /*
     * 接受邀约
     */
    async accept() {
      const { inviteId } = this.detail

      if (this.loginCheck()) {
        try {
          await acceptInvite({ id: inviteId })

          this.fetchDetail() // 刷新详情
          this.$message.success('接受邀约成功')
        } catch (error) {
          this.$message.error(error.message)
        }
      }
    },

    /*
     * 拒绝邀约
     */
    async refused() {
      const { inviteId } = this.detail

      if (this.loginCheck()) {
        try {
          await refusedInvite({ id: inviteId })

          this.fetchDetail() // 刷新详情
          this.$message.success('拒绝邀约成功')
        } catch (error) {
          this.$message.error(error.message)
        }
      }
    },

    /*
     * 上交标书
     */
    submitBids() {
      if (this.loginCheck()) {
        this.showBidDiaolog = true
      }
    },

    /*
     * 自定义上传函数
    */
    async uploadFile(files) {
      const loading = this.$loading({
        text: '提交中..',
        lock: true,
        fullscreen: true
      })

      // 使用formData打包
      const formData = new FormData()
      formData.append('file', files.file)

      try {
        const uploadResult = await uploadFile(formData)
        const { id, inviteId, status, bidStatus } = this.detail
        const params = {
          projectId: id,
          url: uploadResult.data.url
        }

        if (status === 1 && bidStatus) {
          // 更新标书
          await updateBidFile(params)
        } else {
          // 上传标书
          await uploadBidFile(params)
        }

        if (inviteId) {
          this.accept()
        } else {
          this.fetchDetail() // 刷新详情
          this.$message.success('您已投标成功，评标结果会以平台系统消息告知， 请耐心等待平台评标审核，感谢您的参与！')
        }
        this.showBidDiaolog = false
      } catch (error) {
        this.$message.error(error.message)
      }

      loading.close()
    },

    /*
     * 重复上传替换
    */
    uploadChange(file, files) {
      if (file.status === 'ready') {
        // 文件类型限制
        const isPDF = file.raw.type === 'application/pdf'

        if (!isPDF) {
          this.$refs.upload.clearFiles()

          return this.$message.error('上传文件只能是 PDF 格式!')
        }

        this.fileList = files.slice(-1)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.bid-detail {
  position: relative;
  padding-top: 34px;
  padding-bottom: 60px;
  .bid-title {
    font-size: 26px;
    line-height: 40px;
    font-weight: bold;
    white-space: pre-wrap;
  }
  .status-image {
    position: absolute;
    top: 50px;
    right: 30px;
    z-index: 2;
    > img {
      width: 92px;
      height: 92px;
    }
  }
  .bid-info {
    display: flex;
    align-items: flex-start;
    border-bottom: 1px solid #f0f0f0;
    padding: 0 0 8px;
    margin: 40px 0 0;
    .bid-info-item {
      display: flex;
      align-items: center;
      min-width: 280px;
      padding: 0 0 0 25px;
      background-repeat: no-repeat;
      background-position: center left;
      color: #b3b3b3;
      line-height: 20px;
      white-space: nowrap;
      margin: 0 20px 10px 0;
    }
    .bid-info-left {
      display: flex;
      flex-wrap: wrap;
    }
    .bid-release-time {
      background-image: url("~@/assets/images/icon-clock.png");
    }
    .bid-time-deadline {
      background-image: url("~@/assets/images/icon-clock-fill.png");
      > span {
        color: #53ba36;
      }
    }
    .bid-time-end {
      > span {
        color: #f23737;
      }
    }

    .bid-win-company {
      background-image: url("~@/assets/images/icon-aim.png");
    }
    .bid-win-amount {
      background-image: url("~@/assets/images/icon-bid-amount.png");
      > span {
        font-size: 20px;
        color: #333;
      }
    }
    .bid-state {
      min-width: auto;
      background-image: url("~@/assets/images/icon-text.png");
      padding: 0 0 0 22px;
      .state-tag {
        height: 20px;
        line-height: 20px;
        color: #fff;
        font-size: 12px;
        border-radius: 4px;
        text-align: center;
        padding: 0 4px;
        margin: 0 0 0 8px;
      }
      .state-invite {
        background-color: #53ba36;
      }
      .state-review {
        background-color: #FF8A00;
      }
      .state-win {
        background-color: #f57979;
      }
    }
  }
  .bid-wrapper {
    margin: 34px 0 0;
    /deep/ .panel-header {
      align-items: flex-end;
      .panel-title {
        font-size: 20px;
        line-height: inherit;
      }
    }
    .bid-detail-actions {
      .el-button {
        width: 126px;
        font-size: 16px;
        + .el-button {
          margin: 0 0 0 20px;
        }
      }
      .collect-button {
        color: #417ef7;
        border-color: currentColor;
      }
      .cancel-collect-button {
        color: #666;
        border-color: #e6e6e6;
      }
      .uploaded-bids {
        padding: 0 0 0 28px;
        line-height: 20px;
        background-image: url("~@/assets/images/icon-folder-blue.png");
        background-repeat: no-repeat;
        background-position: 0 0;
        color: #6c9cf9;
        margin: 0 38px 0 0;
      }
    }

    .bid-content {
      padding: 20px 0 0;

      .templete-item {
        + .templete-item {
          margin: 15px 0 0;
        }
      }
    }
  }

  /deep/ .el-dialog {
    border-radius: 4px;
    overflow: hidden;
    .el-dialog__body {
      padding: 24px 32px 0;
      .el-form {
        .el-form-item__label {
          padding-right: 35px;
        }
        .el-form-item {
          &:first-child {
            margin: 0 0 35px;
          }
          &:last-child {
            margin: 0;
          }
        }
        .el-upload-list__item-name {
          color: #81aafa;
        }
        .el-upload__tip {
          line-height: 14px;
          color: red;
        }
        .upload-button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100px;
          height: 34px;
          color: #417ef7;
          border-color: currentColor;
          padding: 0;
        }
      }
    }
    .el-dialog__footer {
      text-align: center;
      padding-top: 70px;
      padding-bottom: 70px;
      .submit-button {
        width: 340px;
        height: 44px;
        font-size: 16px;
      }
    }
  }
}
</style>
